import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material";
import AlertBar from "./utilities/UtilityComps/AlertBar";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateAdapter from "@mui/lab/AdapterDateFns";

const theme = createTheme({
  palette: {
    primary: { main: "#253779" },
    secondary: { main: "#ffa600", contrastText: "#fff" }, // I know it's not that contrasting, but the black on yellow looked too much like a warning
    warning: { main: "#ffa600" },
    success: { main: "#0b660b" },
    error: { main: "#7d2121" },
    info: { main: "#64748b" },
  },
});

// any being the imported module
const buildTargets: { [key: string]: () => Promise<any> } = {
  admin: () => import("./Admin/@framing-devices/AdminRoutes"),
  signup_forms: () => import("./SignupForms/SignupRouter"),
  playground: () => import("./Playground/Playground"),
};

async function importBuildTarget() {
  const target = process.env.REACT_APP_BUILD_TARGET;
  if (!target) return import("./utilities/UtilityComps/Error");
  const ret = buildTargets[target];
  if (!ret) return import("./utilities/UtilityComps/Error");
  return ret();
}
importBuildTarget().then(({ default: App }) => {
  ReactDOM.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={DateAdapter}>
          <App />
          <AlertBar />
        </LocalizationProvider>
      </ThemeProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});
